module.exports = "<p>Brisanje Dijagnoze...</p>\n"